// LIBRARIES
import styled from "styled-components";
import Checkbox from "@mui/material/Checkbox";

// MISC
import { BOXSHADOW, COLORS, FONTS } from "constants/styleVariables";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 70px 80px;
  width: 100%;
  height: 100%;

  @media (max-width: 1600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
`;

export const Title = styled.text`
  font-size: 30px;
  font-weight: bold;
  font-family: ${FONTS.newsharp};
  color: ${COLORS.cornflowerBlue};
  margin-bottom: 20px;
`;
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 150px;

  @media (max-width: 1600px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 750px;
  height: 440px;
  padding: 20px 20px 0 20px;
  background: ${COLORS.primaryWhite};
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  border-radius: 10px;

  @media (max-width: 1600px) {
    margin-bottom: 20px;
  }
`;
export const InputContainer = styled.div`
  margin-bottom: 23px;
`;
export const DescriptionContainer = styled.div``;

export const DatesInputContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
export const DateInputContainer = styled.div`
  max-width: 145px;
  margin-right: 15px;
`;
export const UpdatePhotoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const AddPhotoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 760px;
  height: 225px;
  padding: 20px;
  background: ${COLORS.primaryWhite};
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  z-index: 1;
  border-radius: 10px;
  padding: 40px;
`;
export const ButtonUploadDescription = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 350px;
`;
export const DescriptionTitle = styled.text`
  font-size: 22px;
  color: ${COLORS.cornflowerBlue};
  font-weight: bold;
  font-family: ${FONTS.newsharp};
  margin-bottom: 20px;
`;
export const DescriptionText = styled.text`
  font-size: 16px;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.forthGray};
  margin-bottom: 10px;
`;
export const AddedPhotosContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 760px;
  height: 225px;
  background: ${COLORS.primaryWhite};
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  margin-top: -10px;
  border-radius: 10px;
  padding: 40px 10px 20px 40px;
`;
export const SelectedImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
export const SelectedImageDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const SelectedImageDetails = styled.div`
  display: flex;
  flex-direction: column;
`;
export const SelectedImage = styled.img`
  width: 26px;
  height: 30px;
`;
export const SelectedImageName = styled.text`
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 20px;
  font-weight: bold;
  font-size: 16px;
  color: ${COLORS.cornflowerBlue};
  font-family: ${FONTS.newsharp};
  text-decoration: underline;
  text-decoration-color: ${COLORS.cornflowerBlue};
`;
export const SelectedImageDate = styled.text`
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: ${FONTS.montserrat};
  margin-left: 20px;
  color: ${COLORS.fifthGray};
`;
export const SelectedImageButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 35%;
`;
export const SelectedImageChossedImage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const SelectedImageDeleteIcon = styled.img`
  width: 30px;
  height: 30px;
`;
export const ChossedImageLabel = styled.text`
  font-size: 12px;
  color: ${COLORS.fifthGray};
  font-weight: 400;
  font-family: ${FONTS.montserrat};
`;
export const ButtonContainer = styled.div`
  max-width: 169px;
  margin: 0 auto;
`;
export const CheckboxContainer = styled(Checkbox)`
  && {
    padding: 0;
    margin-right: 10px;
    color: ${COLORS.primaryGray};
  }
`;
export const SelectedImageMapContainer = styled.div``;
export const ScrollBarContainer = styled.div`
  padding-right: 27px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.thirdGray};
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.cornflowerBlue} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
    border-radius: 10px;
  }
`;
